export var EFinanceRoundType;
(function (EFinanceRoundType) {
    EFinanceRoundType["SHARE_ISSUE"] = "SHARE_ISSUE";
})(EFinanceRoundType || (EFinanceRoundType = {}));
